import React from "react";
import { Form, Col, Row } from "react-bootstrap";

export function PersonnelContactInfoForm({
  handleChange,
  values
}) {
  return (
    <div className="row">
      <div className="col-6">  
        <Form.Group as={Row} controlId="homePhone">
          <Form.Label column sm={3}>
            Ev Telefonu
          </Form.Label>
          <Col sm={9}>
            <Form.Control type="text" value={values.homePhone} placeholder="Ev Telefonu" onChange={handleChange} />
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="mobilePhone1">
          <Form.Label column sm={3}>
            Cep Telefonu 1
          </Form.Label>
          <Col sm={9}>
            <Form.Control type="text" value={values.mobilePhone1} placeholder="Cep Telefonu 1" onChange={handleChange} />
          </Col>
        </Form.Group>
                        
        <Form.Group as={Row} controlId="mobilePhone2">
          <Form.Label column sm={3}>
            Cep Telefonu 2
          </Form.Label>
          <Col sm={9}>
            <Form.Control type="text" value={values.mobilePhone2} placeholder="Cep Telefonu 2" onChange={handleChange} />
          </Col>
        </Form.Group>
                        
        <Form.Group as={Row} controlId="email1">
          <Form.Label column sm={3}>
            Email 1
          </Form.Label>
          <Col sm={9}>
            <Form.Control type="text" value={values.email1} placeholder="Email 1" onChange={handleChange} />
          </Col>
        </Form.Group>
      </div>          

      <div className="col-6">
        <Form.Group as={Row} controlId="email2">
          <Form.Label column sm={3}>
            Email 2
          </Form.Label>
          <Col sm={9}>
            <Form.Control type="text" value={values.email2} placeholder="Email 2" onChange={handleChange} />
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="city">
          <Form.Label column sm={3}>
            İl<span> *</span>
          </Form.Label>
          <Col sm={9}>
            <Form.Control type="text" value={values.city} placeholder="İl" onChange={handleChange} />
          </Col>
        </Form.Group>
                        
        <Form.Group as={Row} controlId="county">
          <Form.Label column sm={3}>
            İlçe<span> *</span>
          </Form.Label>
          <Col sm={9}>
            <Form.Control type="text" value={values.county} placeholder="İlçe" onChange={handleChange} />
          </Col>
        </Form.Group>
                    
        <Form.Group as={Row} controlId="address">
          <Form.Label column sm={3}>
            Adres<span> *</span>
          </Form.Label>
          <Col sm={9}>
            <Form.Control type="text" value={values.address} placeholder="Adres" onChange={handleChange} />
          </Col>
        </Form.Group>
      </div>
    </div>
  );
}